import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SVGModule } from '@ibe.components/common/svg/svg.module';
import { Ng5SliderModule } from 'ng5-slider';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { CheckboxInputComponent } from './checkbox-input/checkbox-input.component';
import { LargeInputComponent } from './large-input/large-input.component';
import { RadioInputGroupComponent } from './radio-input-group/radio-input-group.component';
import { RadioInputComponent } from './radio-input/radio-input.component';
import { LoadingModule } from '@ibe.components/shared/loading/loading.module';
import { RadioInputCardGroupComponent } from './radio-input-card-group/radio-input-card-group.component';
// import { RangeInputComponent } from './range-input/range-input.component';
// import { DropdownCounterInputComponent } from './dropdown-counter-input/dropdown-counter-input.component';
// import { CounterInputComponent } from './counter-input/counter-input.component';
// import { LargeInputDatepickerComponent } from './large-input-datepicker/large-input-datepicker.component';
// import { LargeInputSelectComponent } from './large-input-select/large-input-select.component';
// import { SelectInputComponent } from './select-input/select-input.component';


/* REPLICATED FILES */
import { CounterInputComponent } from './counter-input/counter-input.indra.component';
import { LargeInputDatepickerComponent } from './large-input-datepicker/large-input-datepicker.indra.component';
import { LargeInputSelectComponent } from './large-input-select/large-input-select.indra.component';
import { INDRASelectInputComponent } from './select-input/select-input.indra.component';
import { INDRASelectBeneficiaryComponent } from './select-beneficiary/select-beneficiary.indra.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { IBEAdminModule } from '@ibe.components/shared/ibe-admin.module';

// From PHASE 1 codes
import { SelectInputIndraComponent } from './select-input-indra/select-input-indra.component';
import { SelectInputIndraModule } from '@ibe.components/common/inputs/select-input-indra/select-input-indra.module';
import { INDRADropdownCounterInputComponent } from './dropdown-counter-input/dropdown-counter-input.indra.component';
import { CheckboxInputIndraComponent } from './checkbox-input-indra/checkbox-input-indra.component';
import { INDRARadioInputGroupComponent } from './radio-input-group/radio-input-group.indra.component';
import { INDRARangeInputComponent } from './range-input/range-input.indra.component';
import { LargeInputLetterOnlyComponent } from './large-input-letter-only/large-input-letter-only.component';
import { LargeInputLetterNumberOnlyComponent } from './large-input-letter-number-only/large-input-letter-number-only.component';



@NgModule({
	imports: [
		CommonModule, 
		FormsModule, 
		SVGModule, 
		LoadingModule, 
		ReactiveFormsModule, 
		Ng5SliderModule, 
		DirectivesModule, 
		PipesModule, 
		SelectInputIndraModule,
		IBEAdminModule
	],
	declarations: [
		CheckboxInputComponent,
		CounterInputComponent,
		RadioInputComponent,
		RadioInputGroupComponent,
		INDRARadioInputGroupComponent,
		RadioInputCardGroupComponent,
		// SelectInputComponent,
		INDRASelectInputComponent,
		INDRASelectBeneficiaryComponent,
		LargeInputComponent,
		LargeInputDatepickerComponent,
		LargeInputSelectComponent,
		LargeInputLetterOnlyComponent,
		LargeInputLetterNumberOnlyComponent,
		// RangeInputComponent,
		INDRARangeInputComponent,
		// DropdownCounterInputComponent
		INDRADropdownCounterInputComponent,
		CheckboxInputIndraComponent
	],
	exports: [
		CheckboxInputComponent,
		CounterInputComponent,
		RadioInputComponent,
		RadioInputGroupComponent,
		INDRARadioInputGroupComponent,
		RadioInputCardGroupComponent,
		// SelectInputComponent,
		SelectInputIndraComponent,
		SelectInputIndraModule,
		INDRASelectInputComponent,
		INDRASelectBeneficiaryComponent,
		LargeInputComponent,
		LargeInputDatepickerComponent,
		LargeInputSelectComponent,
		LargeInputLetterOnlyComponent,
		LargeInputLetterNumberOnlyComponent,
		// RangeInputComponent,
		INDRARangeInputComponent,
		DirectivesModule,
		// DropdownCounterInputComponent,
		INDRADropdownCounterInputComponent,
		PipesModule,
		CheckboxInputIndraComponent
	]
})
export class InputsModule { }
